<template>
    <b-modal
        id="create-vendedor-modal"
        header-bg-variant="primary"
        hide-footer
        no-close-on-backdrop
        :body-class="`${Theme === 'dark' && 'dark'} dialog2`"
        dialog-class="dialog"
        centered
        title="Crear tercero"
        @shown="openModal"
        @close="resetFom"
    >
        <b-card class="mb-4 w-100">
            <div>
                <b-form class="p-5">
                    <div class="d-flex">
                        <div>
                            <h3 class="mb-2">Datos del vendedor</h3>
                            <div class="text-gray mb-5">
                                Por favor registre los datos del vendedor para
                                continuar
                            </div>
                        </div>
                    </div>
                    <b-row>
                        <b-col cols="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label for="codigo">Código</label>
                                <b-form-input
                                    id="codigo"
                                    type="text"
                                    placeholder="Ej: 001"
                                    v-model="$v.vendedor.codigo.$model"
                                    :state="validateState('codigo')"
                                    :disabled="read_only"
                                >
                                </b-form-input>
                                <div
                                    class="length-field mt-1"
                                    v-if="!$v.vendedor.codigo.$anyError"
                                >
                                    ({{ $v.vendedor.codigo.$model.length }}
                                    /
                                    {{
                                        $v.vendedor.codigo.$params.maxLength
                                            .max
                                    }})
                                </div>
                                <b-form-invalid-feedback
                                    v-if="!$v.vendedor.codigo.maxLength"
                                >
                                    Este campo debe tener máximo
                                    {{
                                        $v.vendedor.codigo.$params.maxLength.max
                                    }}
                                    caracteres
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback
                                    v-if="!$v.vendedor.codigo.required"
                                >
                                    Campo requerido
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="9" lg="9" xl="9">
                            <b-form-group>
                                <label for="descripcion">Descripción</label>
                                <b-form-input
                                    id="descripcion"
                                    type="text"
                                    placeholder="Ej: Descripción del vendedor"
                                    v-model="$v.vendedor.descripcion.$model"
                                    :state="validateState('descripcion')"
                                    :disabled="read_only"
                                >
                                </b-form-input>
                                <div
                                    class="length-field mt-1"
                                    v-if="!$v.vendedor.descripcion.$anyError"
                                >
                                    ({{ $v.vendedor.descripcion.$model.length }}
                                    /
                                    {{
                                        $v.vendedor.descripcion.$params
                                            .maxLength.max
                                    }})
                                </div>
                                <b-form-invalid-feedback
                                    v-if="!$v.vendedor.descripcion.maxLength"
                                >
                                    Este campo debe tener máximo
                                    {{
                                        $v.vendedor.descripcion.$params
                                            .maxLength.max
                                    }}
                                    caracteres
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback
                                    v-if="!$v.vendedor.descripcion.required"
                                >
                                    Campo requerido
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-md-4">
                        <b-col cols="12" md="4" lg="4" xl="4">
                            <label for="descripcion">Comisión contado</label>
                            <currencyInput
                                v-model="$v.vendedor.comision_contado.$model"
                                :state="validateState('comision_contado')"
                                :disabled="read_only"
                            />
                            <div
                                class="length-field mt-1"
                                v-if="!$v.vendedor.comision_contado.$anyError"
                            >
                                ({{
                                    $v.vendedor.comision_contado.$model.toString()
                                        .length
                                }}
                                /
                                {{
                                    $v.vendedor.comision_contado.$params
                                        .maxLength.max
                                }})
                            </div>
                            <div
                                class="invalid-field mt-1"
                                v-if="$v.vendedor.comision_contado.$error"
                            >
                                Este campo debe tener máximo
                                {{
                                    $v.vendedor.comision_contado.$params
                                        .maxLength.max
                                }}
                                caracteres
                            </div>
                            <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                        </b-col>
                        <b-col cols="12" md="4" lg="4" xl="4">
                            <label for="descripcion">Comisión 30</label>
                            <currencyInput
                                v-model="$v.vendedor.comision_30.$model"
                                :state="validateState('comision_30')"
                                :disabled="read_only"
                            />
                            <div
                                class="length-field mt-1"
                                v-if="!$v.vendedor.comision_30.$anyError"
                            >
                                ({{
                                    $v.vendedor.comision_30.$model.toString()
                                        .length
                                }}
                                /
                                {{
                                    $v.vendedor.comision_30.$params.maxLength
                                        .max
                                }})
                            </div>
                            <div
                                class="invalid-field mt-1"
                                v-if="$v.vendedor.comision_30.$error"
                            >
                                Este campo debe tener máximo
                                {{
                                    $v.vendedor.comision_30.$params.maxLength
                                        .max
                                }}
                                caracteres
                            </div>
                            <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                        </b-col>
                        <b-col cols="12" md="4" lg="4" xl="4">
                            <label for="descripcion">Comisión 60</label>
                            <currencyInput
                                v-model="$v.vendedor.comision_60.$model"
                                :state="validateState('comision_60')"
                                :disabled="read_only"
                            />
                            <div
                                class="length-field mt-1"
                                v-if="!$v.vendedor.comision_60.$anyError"
                            >
                                ({{
                                    $v.vendedor.comision_60.$model.toString()
                                        .length
                                }}
                                /
                                {{
                                    $v.vendedor.comision_60.$params.maxLength
                                        .max
                                }})
                            </div>
                            <div
                                class="invalid-field mt-1"
                                v-if="$v.vendedor.comision_60.$error"
                            >
                                Este campo debe tener máximo
                                {{
                                    $v.vendedor.comision_60.$params.maxLength
                                        .max
                                }}
                                caracteres
                            </div>
                            <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                        </b-col>
                    </b-row>
                    <b-row class="mt-md-5">
                        <b-col cols="12" md="6" lg="6" xl="6">
                            <label for="descripcion">Comisión 90</label>
                            <currencyInput
                                v-model="$v.vendedor.comision_90.$model"
                                :state="validateState('comision_90')"
                                :disabled="read_only"
                            />
                            <div
                                class="length-field mt-1"
                                v-if="!$v.vendedor.comision_90.$anyError"
                            >
                                ({{
                                    $v.vendedor.comision_90.$model.toString()
                                        .length
                                }}
                                /
                                {{
                                    $v.vendedor.comision_90.$params.maxLength
                                        .max
                                }})
                            </div>
                            <div
                                class="invalid-field mt-1"
                                v-if="$v.vendedor.comision_90.$error"
                            >
                                Este campo debe tener máximo
                                {{
                                    $v.vendedor.comision_90.$params.maxLength
                                        .max
                                }}
                                caracteres
                            </div>
                            <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                        </b-col>
                        <b-col cols="12" md="6" lg="6" xl="6">
                            <label for="descripcion">Comisión 120</label>
                            <currencyInput
                                v-model="$v.vendedor.comision_120.$model"
                                :state="validateState('comision_120')"
                                :disabled="read_only"
                            />
                            <div
                                class="length-field mt-1"
                                v-if="!$v.vendedor.comision_120.$anyError"
                            >
                                ({{
                                    $v.vendedor.comision_120.$model.toString()
                                        .length
                                }}
                                /
                                {{
                                    $v.vendedor.comision_120.$params.maxLength
                                        .max
                                }})
                            </div>
                            <div
                                class="invalid-field mt-1"
                                v-if="$v.vendedor.comision_120.$error"
                            >
                                Este campo debe tener máximo
                                {{
                                    $v.vendedor.comision_120.$params.maxLength
                                        .max
                                }}
                                caracteres
                            </div>
                            <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                        </b-col>
                        <b-col cols="12">
                            <div
                                class="d-sm-flex justify-content-end align-items-center mb-4"
                            >
                                <div class="d-flex flex-row">
                                    <b-button
                                        variant="primary"
                                        :disabled="isLoading || read_only"
                                        size="md"
                                        class="d-flex align-items-center"
                                        v-b-popover.hover.top="
                                            'Presione ctrl+shift+s o cmd+shift+s'
                                        "
                                        @click="save"
                                    >
                                        <feather
                                            type="save"
                                            size="1rem"
                                            class="mr-2 text-blue-active"
                                        />
                                        <span
                                            v-if="isLoading"
                                            class="d-sm-flex align-items-center justify-content-center"
                                        >
                                            <b-spinner small></b-spinner>
                                            <span class="ml-2"
                                                >Guardando...</span
                                            >
                                        </span>
                                        <span v-else>Guardar</span>
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </b-card>
    </b-modal>
</template>
<script>
import services from '@/boot/axios'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapGetters, mapState } from 'vuex'
import currencyInput from '@/components/shared/currency-input/currency-input'
import {
    addListenerCommands,
    removeListenerCommands,
    compareObjects,
    goToNextField
} from '@/utils/others'

const { API } = services

const defaultVendedor = () =>
    JSON.parse(
        JSON.stringify({
            codigo: '',
            descripcion: '',
            // tercero_id: null,
            comision_contado: 0,
            comision_30: 0,
            comision_60: 0,
            comision_90: 0,
            comision_120: 0,
            empresa_id: null
        })
    )

export default {
    name: 'CrearVendedor',
    mixins: [validationMixin],
    components: { currencyInput },
    data: () => ({
        // terceros: [],
        // tercerosCopy: [],
        read_only: false,
        vendedorCopy: defaultVendedor(),
        vendedor: defaultVendedor(),
        isLoading: false,
        isSaved: true
    }),
    watch: {
        vendedor: {
            handler(newValue) {
                this.isSaved = compareObjects(this.vendedorCopy, newValue)
            },
            deep: true
        }
    },
    mounted() {
        addListenerCommands(this)
        // this.getTerceros()
        this.getParams()
    },
    beforeDestroy() {
        removeListenerCommands(this)
    },
    beforeRouteLeave(to, from, next) {
        if (this.isSaved) {
            next()
        } else {
            this.$bvModal
                .msgBoxConfirm(
                    `
        Este formulario contiene información que no ha sido guardada,
        si continua con esta acción no se guardarán los cambios, desea continuar con esta acción?`,
                    {
                        title: 'Advertencia!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Continuar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2 d-flex justify-content-between',
                        hideHeaderClose: false,
                        centered: true,
                        headerBgVariant: 'danger',
                        headerClass: 'modal-header'
                    }
                )
                .then((value) => {
                    if (value) {
                        next()
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    validations: {
        vendedor: {
            codigo: {
                required,
                maxLength: maxLength(20)
            },
            descripcion: {
                required,
                maxLength: maxLength(100)
            },
            // tercero_id: {
            //     required
            // },
            comision_contado: {
                maxLength: maxLength(20)
            },
            comision_30: {
                maxLength: maxLength(20)
            },
            comision_60: {
                maxLength: maxLength(20)
            },
            comision_90: {
                maxLength: maxLength(20)
            },
            comision_120: {
                maxLength: maxLength(20)
            }
        }
    },
    methods: {
        goToNextField,
        showLog(data) {
            console.log(data)
        },
        getParams() {
            const { vendedor_id } = this.$route.params
            if (vendedor_id) {
                this.getVendedorById(vendedor_id)
            }

            this.read_only = this.$route.meta.read_only
        },
        getVendedorById(id) {
            // console.log('acá 2');
            API.POST({
                url: 'administracion/vendedor/query',
                data: {
                    p_datajson: {
                        id
                    },
                    p_opc: 'FIND_BY_ID',
                    p_auditoriajson: this.auditoriajson
                }
            })
                .then((response) => {
                    const {
                        data: {
                            dato,
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    if (status === 'ok') {
                        this.vendedorCopy = { ...dato }
                        this.vendedor = { ...dato }
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        save() {
            const valid = !this.$v.vendedor.$invalid
            if (valid) {
                this.isLoading = true
                const p_opc = this.vendedor.id ? 'UPDATE' : 'INSERT'
                this.vendedor.empresa_id = this.getUltimaEmpresa.id
                API.POST({
                    url: 'administracion/vendedor/crud',
                    data: {
                        p_datajson: {
                            ...this.vendedor
                        },
                        p_opc,
                        p_auditoriajson: this.auditoriajson
                    }
                })
                    .then((response) => {
                        const {
                            data: {
                                dato,
                                status: { status, mensaje, mensaje_exception }
                            }
                        } = response
                        this.isLoading = false
                        if (status === 'ok') {
                            this.isSaved = true
                            this.$emit('newVendedor', dato)
                            this.resetFom()
                            this.close()
                        } else {
                            this.$bvModal
                                .msgBoxOk(
                                    mensaje ||
                                        mensaje_exception ||
                                        'Ha ocurrido un error!',
                                    {
                                        title: 'Error!',
                                        size: 'sm',
                                        buttonSize: 'sm',
                                        okVariant: 'error',
                                        okTitle: 'Aceptar',
                                        cancelTitle: 'Cancelar',
                                        footerClass: 'p-2',
                                        hideHeaderClose: false,
                                        centered: true,
                                        headerBgVariant: 'error',
                                        headerClass: 'modal-header'
                                    }
                                )
                                .then(() => {
                                    // console.log(value);
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false
                        const { message } = error
                        this.$bvModal
                            .msgBoxOk(message || 'Ha ocurrido un error!', {
                                title: 'Error!',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'error',
                                okTitle: 'Aceptar',
                                cancelTitle: 'Cancelar',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true,
                                headerBgVariant: 'error',
                                headerClass: 'modal-header',
                                noStacking: true
                            })
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    })
            } else {
                this.$v.vendedor.$touch()
            }
        },
        validateState(key) {
            const { $dirty, $error } = this.$v.vendedor[key]
            return $dirty ? !$error : null
        },
        openModal() {
            this.goToNextField('codigo')
        },
        resetFom() {
            this.vendedor = defaultVendedor()
            this.$v.vendedor.$reset()
        },
        close() {
            this.$bvModal.hide('create-vendedor-modal')
        }
    },
    computed: {
        auditoriajson() {
            const json = { ...this.getAuditoriaJson, modulo_id: 25 }
            return json
        },
        ...mapGetters('usuario', ['getUserData', 'getAuditoriaJson']),
        ...mapGetters('empresas', ['getUltimaEmpresa']),
        ...mapState(['Theme'])
    }
}
</script>

<style>
.dialog {
    min-width: 80%;
}

.dialog2 {
    min-height: auto;
}
</style>
